import styled from "styled-components";

export const ModalBg = styled.div`
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  display: flex;
  position: fixed;
  background: ${(props) => props.theme.colors.black50};
  align-items: center;
  justify-content: center;
`;

export const Modals = styled.div`
  width: calc(100vw - 32px);
  display: flex;
  max-height: 80vh;
  box-shadow: ${(props) => props.theme.shadows.modal};
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  flex-direction: column;
`;

export const ModalTitle = styled.div`
  color: ${(props) => props.theme.colors.black100};
  display: flex;
  padding: 30px 30px 0;
  font-size: 1.6rem;
  font-weight: 600;
  align-items: center;
  justify-content: space-between;
`;

export const ModalText = styled.div`
  color: ${(props) => props.theme.colors.black80};
  padding: 26px 30px 20px;
  font-size: 1.6rem;
  text-align: center;
  line-height: 160%;

  div {
    span {
      color: ${(props) => props.theme.colors.primary100};
      font-weight: 800;
      text-decoration: underline;
      text-underline-offset: 6px;
    }

    & + div {
      margin-top: 10px;
    }
  }

  p {
    padding: 8px 16px 12px;
    font-size: 1.6rem;
    margin-top: 20px;
    background: ${(props) => props.theme.colors.black5};
    font-weight: 800;
    border-radius: 8px;

    span {
      color: ${(props) => props.theme.colors.primary100};
      display: inline-block;
      font-size: 1.2rem;
      font-weight: 700;
    }
  }
`;

export const ModalContent = styled.div`
  height: auto;
  display: flex;
  overflow: hidden;
  font-size: 1.6rem;
  align-items: center;
  flex-direction: column;
`;

export const ModalButtons = styled.div`
  gap: 4px;
  display: flex;
  padding: 4px;
  align-items: center;
`;
